import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 22V4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 15s1-1 4-1 5 2 8 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlagOff";
const FlagOff = memo(themed(Icon));
export {
  FlagOff
};
//# sourceMappingURL=flag-off.js.map
